'use client';

import { useState, useEffect, useMemo, useCallback } from 'react';
import { Button, useI18n, Modal, useNavigate, useQueryState } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';
import { useWalletKitConnect } from '@ywwwtseng/wallet-kit';
import { isAfter } from '@/lib/dayjs';
import type { SelectUser } from '@/types';

const STORAGE_KEY = 'share_red_packet_prompt_dismissed';

export function ShareRedPacketPromptModal() {
  const me = useQueryState<SelectUser>('me');
  const walletKitConnect = useWalletKitConnect();

  const { t } = useI18n();
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === 'undefined') return false;
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });
  const navigate = useNavigate();

  useEffect(() => {
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') setDismissed(true);
    } catch { }
  }, []);

  const open = useMemo(() => {
    if (dismissed) return false;
    if (me) {
      if (!me.invited_by) {
        return false;
      }

      if (me.fission_moonini_total !== '0') {
        return false;
      }

      return isAfter(me.created_at, '2026-02-08', 'system');
    }

    return false;
  }, [me?.invited_by, me, dismissed]);

  const onClose = useCallback((dismissedThisSession: boolean) => {
    setDismissed(true);
    try {
      if (dismissedThisSession) {
        sessionStorage.setItem(STORAGE_KEY, '1');
      }
    } catch { }
  }, []);

  return (
    <Modal
      open={open}
      onClose={() => {
        walletKitConnect.connectedCallbacks.bsc = [];
        onClose(true);
      }}
      title={t('share_red_packet_prompt.title')}
      classes={{
        content: 'border-1 border-gray-700/10 md:max-w-[400px] md:mx-auto p-4',
      }}
    >
      <Typography size="2" whitespacePreWrap>
        {t('share_red_packet_prompt.title')}
      </Typography>


      <Typography size="2" whitespacePreWrap className="mb-2" textAlign="center">
        {t('share_red_packet_prompt.description')}
      </Typography>

      <div className="flex flex-col gap-2 w-full mt-4">
        <Button
          width="full"
          color="primary"
          variant="contained"
          size="sm"
          rounded="full"
          onClick={() => {
            if (walletKitConnect.accounts.bsc.isConnected) {
              navigate('AccountVerification0');
            } else {
              walletKitConnect.connectedCallbacks.bsc = [
                () => {
                  navigate('AccountVerification0');
                }
              ];

              void walletKitConnect.open();
            }

            onClose(false);
          }}
          className="gap-2"
        >
          {t('common.verify')}
        </Button>
      </div>
    </Modal>
  );
}
